import {
    REQUEST_PRODUCT,
    REQUEST_PRODUCT_SUCCESS,
    REQUEST_PRODUCT_ERROR,
    REQUEST_SUPPLIER,
    REQUEST_SUPPLIER_SUCCESS,
    REQUEST_SUPPLIER_ERROR,
    REQUEST_DELIVERY_ORDER,
    REQUEST_DELIVERY_ORDER_SUCCESS,
    REQUEST_DELIVERY_ORDER_ERROR,
    REQUEST_UNIT_HEALTH,
    REQUEST_UNIT_HEALTH_SUCCESS,
    REQUEST_UNIT_HEALTH_ERROR,
    REQUEST_TICKET,
    REQUEST_TICKET_SUCCESS,
    REQUEST_TICKET_ERROR,
    REQUEST_SERIAL,
    REQUEST_SERIAL_SUCCESS,
    REQUEST_SERIAL_ERROR,
    REQUEST_REQ_TYPE,
    REQUEST_REQ_TYPE_SUCCESS,
    REQUEST_REQ_TYPE_ERROR,
    REQUEST_PRIORITY,
    REQUEST_PRIORITY_SUCCESS,
    REQUEST_PRIORITY_ERROR,
    REQUEST_DOCUMENT_TYPE,
    REQUEST_DOCUMENT_TYPE_SUCCESS,
    REQUEST_DOCUMENT_TYPE_ERROR,
    REQUEST_STATUS,
    REQUEST_STATUS_SUCCESS,
    REQUEST_STATUS_ERROR,
    REQUEST_LIST,
    REQUEST_LIST_SUCCESS,
    REQUEST_LIST_ERROR,
    REQUEST_LIST_SEARCH_CHANGE,
    REQUEST_LIST_PAGE_SET,
    REQUEST_DETAIL,
    REQUEST_DETAIL_SUCCESS,
    REQUEST_DETAIL_ERROR,
    REQUEST_MODAL_SET,
    REQUEST_DATA_SET,
    REQUEST_EDIT_MODAL_SET,
    REQUEST_EDIT_CHANGE_SET,
    REQUEST_EDIT,
    REQUEST_EDIT_SUCCESS,
    REQUEST_EDIT_ERROR,
    REQUEST_UPLOAD_SET,
    REQUEST_UPLOAD_SET_SUCCESS,
    REQUEST_UPLOAD_SET_ERROR,
    REQUEST_UPLOAD_RESET
} from "../../actions";

const INIT_STATE = {
    loading: false,
    list: {
        page: {
            current: 1,
            rows: 10
        }
    },
    product: {
        loading: false,
        data: []
    },
    supplier: {
        loading: false,
        data: []
    },
    deliveryorder: {
        loading: false,
        data: []
    },
    unithealth: {
        loading: false,
        data: []
    },
    ticket: {
        loading: false,
        data: []
    },
    serial: {
        loading: false,
        data: []
    },
    requesttype: {
        loading: false,
        data: []
    },
    priority: {
        loading: false,
        data: []
    },
    documenttype: {
        loading: false,
        data: []
    },
    status: {
        loading: false,
        data: []
    },
    datadetail: {
        loading: false,
        modal:false,
        data: []
    },
    detail: {
        loading: false,
        data: []
    },
    edit: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    file: [],
    error: false,
    search: {
        modal: false,
        init: true,
        data: {
            ticket: '',
            product: '',
            serial: '',
            deliveryorder: '',
            supplier: '',
            requesttype: '',
            priority: '',
            unithealth: '',
            status:''
        },
        value: {
            ticket: '',
            product: '',
            serial: '',
            deliveryorder: '',
            supplier: '',
            requesttype: '',
            priority: '',
            unithealth: '',
            status:''
        }
    }
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case REQUEST_PRODUCT:
            return {
                ...state,
                loading: true,
                product: {
                    ...state.product
                }
            }
        case REQUEST_PRODUCT_SUCCESS:
            return {
                ...state,
                loading: false,
                product: {
                    ...state.product,
                    ...action.payload
                }
            }
        case REQUEST_PRODUCT_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case REQUEST_SUPPLIER:
            return {
                ...state,
                loading: true,
                supplier: {
                    ...state.supplier
                }
            }
        case REQUEST_SUPPLIER_SUCCESS:
            return {
                ...state,
                loading: false,
                supplier: {
                    ...state.supplier,
                    ...action.payload
                }
            }
        case REQUEST_SUPPLIER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case REQUEST_DELIVERY_ORDER:
            return {
                ...state,
                loading: true,
                deliveryorder: {
                    ...state.deliveryorder
                }
            }
        case REQUEST_DELIVERY_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                deliveryorder: {
                    ...state.deliveryorder,
                    ...action.payload
                }
            }
        case REQUEST_DELIVERY_ORDER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case REQUEST_UNIT_HEALTH:
            return {
                ...state,
                loading: true,
                unithealth: {
                    ...state.unithealth
                }
            }
        case REQUEST_UNIT_HEALTH_SUCCESS:
            return {
                ...state,
                loading: false,
                unithealth: {
                    ...state.unithealth,
                    ...action.payload
                }
            }
        case REQUEST_UNIT_HEALTH_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case REQUEST_TICKET:
            return {
                ...state,
                loading: true,
                ticket: {
                    ...state.ticket
                }
            }
        case REQUEST_TICKET_SUCCESS:
            return {
                ...state,
                loading: false,
                ticket: {
                    ...state.ticket,
                    ...action.payload
                }
            }
        case REQUEST_TICKET_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case REQUEST_SERIAL:
            return {
                ...state,
                loading: true,
                serial: {
                    ...state.serial
                }
            }
        case REQUEST_SERIAL_SUCCESS:
            return {
                ...state,
                loading: false,
                serial: {
                    ...state.serial,
                    ...action.payload
                }
            }
        case REQUEST_SERIAL_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case REQUEST_REQ_TYPE:
            return {
                ...state,
                loading: true,
                requesttype: {
                    ...state.requesttype
                }
            }
        case REQUEST_REQ_TYPE_SUCCESS:
            return {
                ...state,
                loading: false,
                requesttype: {
                    ...state.requesttype,
                    ...action.payload
                }
            }
        case REQUEST_REQ_TYPE_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case REQUEST_PRIORITY:
            return {
                ...state,
                loading: true,
                priority: {
                    ...state.priority
                }
            }
        case REQUEST_PRIORITY_SUCCESS:
            return {
                ...state,
                loading: false,
                priority: {
                    ...state.priority,
                    ...action.payload
                }
            }
        case REQUEST_PRIORITY_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case REQUEST_DOCUMENT_TYPE:
            return {
                ...state,
                loading: true,
                documenttype: {
                    ...state.documenttype
                }
            }
        case REQUEST_DOCUMENT_TYPE_SUCCESS:
            return {
                ...state,
                loading: false,
                documenttype: {
                    ...state.documenttype,
                    ...action.payload
                }
            }
        case REQUEST_DOCUMENT_TYPE_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case REQUEST_STATUS:
            return {
                ...state,
                loading: true,
                status: {
                    ...state.status
                }
            }
        case REQUEST_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                status: {
                    ...state.status,
                    ...action.payload
                }
            }
        case REQUEST_STATUS_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case REQUEST_LIST:
            return {
                ...state,
                loading: true,
                list: {
                    ...state.list
                }
            }

        case REQUEST_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case REQUEST_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case REQUEST_LIST_PAGE_SET:
            return {
                ...state,
                list: {
                    ...state.list,
                    page: {
                        ...state.list.page,
                        ...action.payload,
                    }
                }
            }
        case REQUEST_LIST_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case REQUEST_DETAIL:
            return {
                ...state,
                loading: true,
                detail: {
                    ...state.detail
                }
            }
        case REQUEST_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                detail: {
                    ...state.detail,
                    ...action.payload
                }
            }
        case REQUEST_DETAIL_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case REQUEST_MODAL_SET:
            return {
                ...state,
                datadetail: {
                    ...state.datadetail,
                    modal: action.payload
                }
            }
        case REQUEST_DATA_SET:
            return {
                ...state,
                datadetail: {
                    ...state.datadetail,
                    data: {
                        ...state.datadetail.data,
                        ...action.payload
                    }
                }
            }
        case REQUEST_EDIT_MODAL_SET:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    modal: action.payload
                }
            }
        case REQUEST_EDIT_CHANGE_SET:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    data: {
                        ...state.edit.data,
                        ...action.payload
                    }
                }
            }
        case REQUEST_EDIT:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    loading: false
                }
            }
        case REQUEST_EDIT_SUCCESS:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case REQUEST_EDIT_ERROR:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case REQUEST_UPLOAD_SET:
            return { ...state };

        case REQUEST_UPLOAD_SET_SUCCESS:
            return {
                ...state,
                file: { ...state.file, ...action.payload }
            };

        case REQUEST_UPLOAD_SET_ERROR:
            return {
                ...state,
                file: { ...state.file, ...action.payload }
            };

        case REQUEST_UPLOAD_RESET:
            return {
                ...state,
                file: []
            };
        default:
            return { ...state };
    }
};